module.exports = __webpack_public_path__ + "img/add.86bb16a2.svg";